<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :allowFields="$lang.searchInterviewLocationPlan"
      ref="searchInterviewLocationPlan"
      :url="url"
      :title="$lang.interview_location_plan"
      :remove_item="remove_item"
      :toggleable="true"
      addModalSize="lg"
      removeModalSize="xl"
      :dynamicButtons="buttons"
      :defaultViewCount="50"
      primaryKey="id"
      @showPlace="showPlace"
      :filterCatch="true"
      @getPermisson="getPermissions"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <AddInterviewLocationPlan
          @closeModal="search.close"
          @getItems="getItems"
        />
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_add"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <EditInterviewLocationPlan
        :itemId="itemId"
        @closeModal="closeModal"
        @getItems="getItems"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddInterviewLocationPlan from "./addInterviewLocationPlan";
import EditInterviewLocationPlan from "./editInterviewLocationPlan";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "search-interview-locations-plan",
  inject: ["interviewLocationPlanRepository"],
  components: {
    Search,
    AddInterviewLocationPlan,
    EditInterviewLocationPlan,
  },
  data() {
    return {
      id: this.$route.params.id,
      hiddenFields: [],
      view_add: false,
      buttons: [
        {
          id: "0",
          name: "edit",
          click: this.modalEdit,
        },
        {
          id: "0",
          name: "userGraduate",
          click: this.userGraduate,
        },
        {
          id: "0",
          name: "determination",
          click: this.determination,
        },

        {
          id: "1",
          name: "view",
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      permissions: [],
      itemId: null,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["interview", "interview_location_plan"]);
    },
  },
  methods: {
    isAdmin,
    generateApiUrl,
    determination(item) {
      const routeData = this.$router.resolve({
        name: "interviewLocationAudience",
        params: {
          id: item.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    userGraduate(item) {
      const routeData = this.$router.resolve({
        name: "searchInterviewLocationPerson",
        params: {
          id: item.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    closeModal() {
      this.view_add = false;
    },
    getItems() {
      this.$refs.searchInterviewLocationPlan.getItems();
    },
    modalEdit(item) {
      this.itemId = item.id;
      this.view_add = true;
    },
    showPlace(item) {
      const routeData = this.$router.resolve({
        name: "placeIninterviewLocationPlan",
        params: {
          id: item.interview_location_id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    async remove_item(item) {
      try {
        const response = await this.interviewLocationPlanRepository.delete(
          item.id
        );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    getPermissions(permissions) {
      this.permissions = permissions;
    },
  },
};
</script>
